import { render, staticRenderFns } from "./ExchangeIntegralGoods.vue?vue&type=template&id=49063ed6&scoped=true"
import script from "./ExchangeIntegralGoods.vue?vue&type=script&lang=js"
export * from "./ExchangeIntegralGoods.vue?vue&type=script&lang=js"
import style0 from "./ExchangeIntegralGoods.vue?vue&type=style&index=0&id=49063ed6&prod&lang=scss&scoped=true"
import style1 from "./ExchangeIntegralGoods.vue?vue&type=style&index=1&id=49063ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49063ed6",
  null
  
)

export default component.exports